import { render, staticRenderFns } from "./inventory-filter.vue?vue&type=template&id=1a043a27&scoped=true&"
import script from "./inventory-filter.vue?vue&type=script&lang=js&"
export * from "./inventory-filter.vue?vue&type=script&lang=js&"
import style0 from "./inventory-filter.vue?vue&type=style&index=0&id=1a043a27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a043a27",
  null
  
)

export default component.exports